import { motion } from 'framer-motion'
import { Box } from '@chakra-ui/react'

const pageVariants = {
  initial: {
    opacity: 0,
    x: -20
  },
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut'
    }
  },
  exit: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.2,
      ease: 'easeIn'
    }
  }
}

const PageTransition = ({ children }: { children: React.ReactNode }) => (
  <Box as={motion.div}
    initial="initial"
    animate="enter"
    exit="exit"
    variants={pageVariants}
    style={{ width: '100%' }}
  >
    {children}
  </Box>
)

export default PageTransition
